import React from "react";
import { JsonEditor } from "json-edit-react";
import { useFormContext } from "react-hook-form";
import { NODE_ENV } from "common/env";
import formResolver from "../formResolver";
import { SubmissionsBuilderFormDataStructure } from "../types";

const FormJSONPreview = () => {
  const { getValues, reset } =
    useFormContext<SubmissionsBuilderFormDataStructure>();

  const formValues = getValues();
  const errors = formResolver(formValues).errors;

  const canEdit = NODE_ENV === "development";

  return (
    <div>
      <JsonEditor
        maxWidth={"100%"}
        restrictEdit={!canEdit}
        restrictAdd={!canEdit}
        restrictDelete={!canEdit}
        data={{ ...formValues, errors }}
        onUpdate={({ newData }) => {
          reset(newData);
        }}
      />
    </div>
  );
};

export default FormJSONPreview;
